import React from 'react';
import PropTypes from 'prop-types';
import { head } from 'lodash/fp';

import Logo from '../../../../components/UIContainer/MobileUI/header/components/Logo/index';
import HeaderImage from './HeaderImage/index';
import renderOnResolutionChange from '../../../../components/RenderOnResolutionChange/index';
import { practiceProfilePropType } from '../../../propTypes/index';
import { userPropType } from '../../../../components/UIContainer/MobileUI/Menu/propTypes/index';
import styles from './desktopHeader.module.css';

const DesktopHeader = ({
  practice,
  user,
  isLoggedIn,
  logOut,
  goHome,
  goVensa,
  id,
}) => (
  <div className={styles.container}>
    <div className={styles.banner}>
      <div>
        <Logo className={styles.logo} onClick={goVensa} blue />
      </div>
      {isLoggedIn ? (
        <div>
          {user.FirstName && (
            <div className={styles.user} onClick={goHome}>
              {user.AvatarUrl && (
                <img src={user.AvatarUrl} alt={user.FirstName} />
              )}
              {`${user.FirstName} ${user.LastName}`}
            </div>
          )}
          <div className={styles.logOut} onClick={logOut}>
            Log out
          </div>
        </div>
      ) : (
        <div>
          <a
            className={styles.logIn}
            href={`${window.location.origin}/login?page=practice-profile/${practice.UrlName}`}
          >
            Log in / Join
          </a>
          <a className={styles.list} href="https://vensa.com">
            List your practice
          </a>
        </div>
      )}
    </div>
    <HeaderImage url={head(practice.Pictures)} />
  </div>
);
DesktopHeader.propTypes = {
  practice: practiceProfilePropType.isRequired,
  isLoggedIn: PropTypes.bool,
  user: userPropType,
  logOut: PropTypes.func.isRequired,
  goHome: PropTypes.func.isRequired,
  id: PropTypes.string,
};
export default renderOnResolutionChange(DesktopHeader);
